<template>
  <div class="pb-16 pt-6 lg:py-24">
    <div class="mx-auto w-full max-w-screen-xl container">
      <VcImage :src="image" :alt="alttext" lazy />
    </div>
  </div>
</template>

<script setup lang="ts">
export interface IProps {
  image: string;
  alttext: string;
  background?: string;
}

defineProps<IProps>();
</script>
